// RETORNO PARA A ASSALCE (#189) — formato 3.0, de 01/10/2026.
//
// TXT sem cabecalho, `;`, ASCII, CRLF, nome `RETASS{AAAAMM}.txt`, quatro
// colunas, uma linha por CONTRATO de cada linha do retorno da ALECE nas
// rubricas dela — inclusive a que nao teve desconto:
//
//   matricula;cpf;verba;valorDescontado
//   001476;12345678909;807;250,00
//   001476;12345678909;807;120,00
//   000130;18366031187;640;0,00
//
// A 2.0 (30/09) levava sete colunas — contrato, instruido e motivo — e a
// ASSALCE pediu as quatro de volta. Ficou o resto da 2.0: tudo o que esta no
// FOLHA vai, a linha sem desconto sai com 0,00, e os contratos de uma mesma
// linha da folha saem SEPARADOS, cada um com o seu valor. Nada e' somado
// aqui: uma linha de entrada, uma linha de saida. Os demais credores seguem no
// formato de sete colunas (`consignataria-retorno`).
//
// Matricula e verba saem como a ALECE as escreveu no FOLHA (a ASSALCE casa pelo
// formato dela, que desde 202609 e' o mesmo — 6 digitos com zeros); o valor e'
// o que a folha descontou do contrato, com virgula decimal e sem zeros a
// esquerda. Quem separa por contrato e' a API (a conciliacao decide o rateio);
// aqui e' so' a forma.
import { layoutDoCatalogo } from "../catalogo.js";
import { cpf11, juntarLinhas, nomeRetass, reais } from "../consignataria/forma-retorno.js";
const CODIGO = "assalce-retorno";
const SEPARADOR = ";";
function versao() {
    return layoutDoCatalogo(CODIGO).versao;
}
export const adaptadorAssalceRetorno = {
    codigo: CODIGO,
    serializar(entrada) {
        // Ordenacao estavel: os contratos da mesma linha da folha ficam na ordem
        // em que a API os entregou.
        const ordenadas = [...entrada.linhas].sort((a, b) => a.linha - b.linha);
        const zeradas = ordenadas.filter((l) => l.descontadoCentavos <= 0).length;
        let cpfsCompletados = 0;
        const linhas = ordenadas.map((l) => {
            const c = cpf11(l.cpf);
            if (c.completado)
                cpfsCompletados++;
            return [l.matricula, c.valor, l.rubrica, reais(l.descontadoCentavos)].join(SEPARADOR);
        });
        const avisos = [];
        if (ordenadas.length === 0)
            avisos.push("sem linhas nas rubricas do credor nesta competência: o arquivo sai vazio");
        if (zeradas > 0)
            avisos.push(`${zeradas} linha(s) sem desconto saem com 0,00`);
        if (cpfsCompletados > 0)
            avisos.push(`${cpfsCompletados} CPF(s) vieram curtos e foram completados com zeros a esquerda`);
        // Varios contratos da MESMA linha da folha repetem matricula e verba por
        // desenho. Repeticao a avisar e' a de LINHAS DIFERENTES da folha (a mesma
        // pessoa em duas folhas): o arquivo nao tem coluna para distingui-las.
        const linhasDaFolha = new Map();
        for (const l of ordenadas) {
            const k = [l.matricula, l.rubrica].join(SEPARADOR);
            linhasDaFolha.set(k, (linhasDaFolha.get(k) ?? new Set()).add(l.linha));
        }
        for (const [k, origens] of linhasDaFolha) {
            if (origens.size > 1) {
                avisos.push(`matrícula e verba ${k} vêm de ${origens.size} linhas da folha: mais de uma folha para a mesma pessoa`);
            }
        }
        const relatorio = {
            layout: { codigo: CODIGO, versao: versao() },
            competencia: entrada.competencia,
            linhas: linhas.length,
            dividasInstruidas: ordenadas.length,
            dividasSomadas: [],
            identificadorEscrito: false,
            camposSemCorrespondencia: cpfsCompletados > 0 ? ["cpf"] : [],
            totaisPorCredor: [],
            avisos,
        };
        return {
            arquivos: [{
                    nome: this.nomeArquivo(entrada.competencia),
                    texto: juntarLinhas(linhas),
                    codificacao: "utf-8",
                    contentType: "text/plain; charset=us-ascii",
                }],
            relatorio,
        };
    },
    nomeArquivo(competencia) {
        return nomeRetass(competencia);
    },
};
//# sourceMappingURL=assalce-retorno.js.map